module.exports = __webpack_public_path__ + "img/jcsjcjwg2.9ccfaf41.png";